import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'product-item',
  templateUrl: './product-item.html',
  standalone: false,
})
export class ProductItemComponent implements OnInit {
  orderPlaced: any;
  active: any;
  @Input() user: any;
  @Input() userLanguage: any;
  @Input('product') main: any;
  @Input('activeExperiments') activeExperiments: any[];
  @Input('regimen')
  set regimenData(regimen: any) {
    this.orderPlaced = regimen.orderPlaced;
    this.active = regimen.active;
  }
  @Input() itemIndex: number = 0;
  @Output() playVideo: EventEmitter<any> = new EventEmitter();
  @Output() openCarousal: EventEmitter<any> = new EventEmitter<number>();

  product: any;
  purpose: any;
  instructions: any;
  instructionSet: any;
  showProductDescription: boolean = true;
  ingredients: any;
  expansionPanel: { application: boolean, advice: boolean } = { advice: false, application: false };
  overrideRegimen: boolean = false;

  constructor(private readonly route: ActivatedRoute) {}

  async ngOnInit(): Promise<any> {
    this.overrideRegimen = this.route?.snapshot?.queryParams?.overrideRegimen === 'true';
    if (this.itemIndex === 0) this.expansionPanel = { advice: true, application: true };

    this.instructionSet = this.main?.instructionSet || {};
    for (const each of Object.keys(this.instructionSet)) {
      if (each && this.instructionSet[each] && typeof this.instructionSet[each] === 'string') {
        this.instructionSet[each] = this.instructionSet[each].trim().replace('N/A', '').trim();
      }
    }
    this.activeExperiments?.forEach((each: any): void => {
      this.showProductDescription = true;
    });
    this.instructions = this.main?.instruction || [];
    this.product = this.main?.product;
    this.purpose = this.product?.purpose;
    if (typeof this.product?.ingredients === 'string') this.ingredients = this.product?.ingredients;
  }

  toggleExpansion(panelName: string): any {
    return this.expansionPanel[panelName] = !this.expansionPanel[panelName];
  }

  onImageClick(event: Event, index: number): void {
    event.stopPropagation(); // Prevent the click event from bubbling up
    this.openCarousal.emit(index);
  }

  get getProductImage(): string | null {
    if (this.overrideRegimen) {
      return this.product?.productImage;
    }
    return this.product?.rebrandedImageWithoutBackground?.at(-1)
    ?? this.product?.productUnboxedImage?.at(-1)
    ?? null;
  }
}
